import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect ,useState} from "react";
import HoverImage from "react-hover-image/build";
import { Button } from "reactstrap";
import { currencyFormat,cellRendererCheck,dateFormate } from "utils/columns";
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";



const PunchoutDetails = (props)=>{
const {collapseSider,setKey,key,demodata} = props;
    const [data,setData]= useState([]);
useEffect(()=>{
setData(demodata);
},[demodata])
    const renderCancal = (rowData) => {
 
      return (
          <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => handelAll(rowData,1204)}
              title='Cancel'
          >
              <HoverImage
                  key='CancleIcon'
                  src={CancleIcon}
                  hoverSrc={CancleHoverIcon}
                  alt=''
              />
          </Button>
      );
    };
    const rendereligible = (rowData) => {
      
      return (
          <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
            //  onClick={() => handelAll(rowData,1203)}
              title='Authorize'
          >
              <HoverImage
                  key='SaveIcon'
                  src={SaveIcon}
                  hoverSrc={SaveHoverIcon}
                  alt=''
              />
          </Button>
      );
  };
const handelViewpunch = (row)=>{
  setKey('Details')
}
  const renderEdit = (rowdata)=>{
    return(
      <Button
      className="text-primary p-0 text-decoration-none"
      color="link"
     
     onClick={() => toggleEdit(rowdata)}
    >
      <HoverImage
        src={EditIcon}
        hoverSrc={EditHoverIcon}
        alt=""
      />
    </Button>
    )
  }
    const renderViewButton = (rowData) => {
      return (
          <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
             onClick={() => handelViewpunch(rowData)}
              title='view'
          >
              <HoverImage
                  key='EyeIcon'
                  src={EyeIcon}
                  hoverSrc={EyeIconHover}
                  alt=''
              />
          </Button>
      );
  };
    const cellRenderEdit = (rowData) => {
      return (
        <div className="d-flex align-items-center">
          
          {rendereligible(rowData)}
          {/* {renderEdit(rowData)} */}
          {renderViewButton(rowData)}
          {renderCancal(rowData)}
     
        </div>
      );
    };
  let mainCol = [
    {
      dataField: "edit",
      text: "Option",
       cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "sourcepo",
      text: "Source PO #",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.sourcepo),
    },
    {
      dataField: "hospitalname",
      text: "Hospital Name",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.hospitalname),
    },
    {
      dataField: "accntype",
      text: "Account Type",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.accntype),
    },
    {
      dataField: "acct",
      text: "Acct #",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.acct),
    },
    {
      dataField: "podate",
      text: "PO Date",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.podate),
    },
    {
      dataField: "potype",
      text: "PO Type",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.potype),
    },
    {
      dataField: "wholename",
      text: "Wholesaler Name",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.wholename),
    },
    {
      dataField: "postatus",
      text: "Status",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.postatus),
    },
    // {
    //   dataField: "reason",
    //   text: "Reason",
    //   sort: false,
    //   width: 100,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: true,
    //   cellRenderer: (row) => cellRendererCheck(row.reason),
    // },
    {
      dataField: "updatedDate",
      text: "Order Price",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.updatedDate),
    },
   
    // {
    //   dataField: "maped",
    //   text: "Maped",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: true,
    //   cellRenderer: (row) => cellRendererCheck(row.maped),
    // },
    //  {
    //   dataField: "gcnmaping",
    //   text: "GCN Maping",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: true,
    //   cellRenderer: (row) => cellRendererCheck(row.gcnmaping),
    // },
    // {
    //   dataField: "notes",
    //   text: "Notes",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: true,
    //   cellRenderer: (row) => cellRendererCheck(row.notes),
    // },
    
   
  ];


    return(
        <div  className='table-card scroll-table position-relative border-0 rounded pt-0'
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
            <ReactStrapTable
             id="configuration-table"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          data={data}
          columns={mainCol}
          // hasPagination
         // filters={filters}
          //totalRecords={totalitem}
          pageSize={10}
          currentPage={1}
         
          collapseSider={collapseSider}
         
                showtoggle={true} />
        </div>
    )
}
export default PunchoutDetails;